export const disableScroll = ({disableEvents = false} = {}) => {
  Object.assign(document.documentElement.style, {
    pointerEvents: disableEvents ? 'none' : '',
    overflow: 'hidden',
    height: '100%',
  });
};

export const enableScroll = () => {
  Object.assign(document.documentElement.style, {
    pointerEvents: '',
    overflow: '',
    height: '',
  });
};
